import { useEffect, useState } from 'react'

import { ClearSocketMessageHandler, GetActiveStadiumZones, GetUserZone, ResetAllResults, SetSocketMessageHandler } from './../../utilities/BL/Zones'
import { GetLotteryData, GetNewLotteryData, RemoveExtraClassesOfColorsDynamic, SaveLotteryData } from './../../utilities/BL/Games'

import { Welcome } from './Sections/Welcome'
import { Wait } from './Sections/Wait'
import { Quiz } from './Sections/Quiz'
import { Colors } from './Sections/Colors'
import { Thanks } from './Sections/Thanks'
import { InstructionsColors } from './Sections/InstructionsColor'
import { Lottery } from './Sections/Lottery'
import { Balloons } from './Sections/Balloons'
import { Riddle } from './Sections/Riddle'
import { QuizzWithImageAndOptions } from './Sections/QuizzWithImageAndOptions'
import { Noisemeter } from './Sections/Noisemeter'
import { FrontPageNoisemeter } from './Sections/Noisemeter/FrontPageNoisemeter'
import { NoisemeterV2 } from './Sections/NoisemeterV2'
import { FrontPageNoisemeterV2 } from './Sections/Noisemeter/FrontPageNoisemeterV2'
import { FrontPageLuchoFest } from './Sections/LuchoFest/FrontPageLuchoFest'
import { LuchoFest } from './Sections/LuchoFest'
import { LightShow } from './Sections/LightShow'
import { Picnic } from './Sections/Picnic'
import { Tacos } from './Sections/Tacos'

// IMPORTAMOS EL NUEVO COMPONENTE V2 DEL AFICIONADO
import { GoalV2 } from './Sections/GoalV2'

import { Voting } from './Sections/Voting'
import { SequenceFan } from './Sections/SequenceFan'
import { TugOfWarFan } from './Sections/TugOfWarFan'
import { MemoryPlayer } from './Sections/MemoryPlayer'

import { DeleteSessionData } from './../../utilities/BL/Sessions'


const Sections = () => {
    // =========================================================================
    // 1. AJUSTE ORTOGRÁFICO: Debe coincidir EXACTAMENTE con VaronilZones del C#
    // =========================================================================

    // const zonesTemplate = [
    //     { name: "Zona Laboratorio Tequis", text: "laboratorio tequis" },
    //     { name: "Zona Canels", text: "canels" },
    //     { name: "Zona Seguros El Potosí", text: "seguros el potosí" }, // <--- AGREGADO EL ACENTO
    //     { name: "Zona Red Cola", text: "red cola" },
    //     { name: "Zona Tecate", text: "tecate" },
    //     { name: "Zona Moctezuma", text: "moctezuma" },
    //     { name: "Zona Nissan", text: "nissan" },
    //     { name: "Zona Mobil", text: "mobil" },
    //     { name: "Zona Lounge Ron Potosí", text: "lounge ron potosí" }, // <--- AGREGADO EL ACENTO
    //     { name: "Zona Azul", text: "azul" },
    //     { name: "Zona Oro", text: "oro" }
    // ]

    const zonesTemplate = [
        { name: "Zona Laboratorio Tequis", text: "laboratorio tequis" },
        // { name: "Zona Canels", text: "canels" },
        { name: "Zona San Luis", text: "san luis" },
        { name: "Zona Seguros El Potosí", text: "seguros el potosí" },
        { name: "Zona Red Cola", text: "red cola" },
        // { name: "Zona Tecate", text: "tecate" },
        { name: "Zona Corona", text: "tecate" },
        { name: "Zona Moctezuma", text: "moctezuma" },
        // { name: "Zona Nissan", text: "nissan" },
        { name: "Zona Atleti", text: "nissan" },
        { name: "Zona Mobil", text: "mobil" },
        // { name: "Zona Lounge Ron Potosí", text: "lounge ron potosí" }, // <--- AGREGADO EL ACENTO
        { name: "Zona Palcos", text: "palcos" },
        { name: "Zona Azul", text: "azul" },
        { name: "Zona Oro", text: "oro" },
        //Temporales
        { name: "Team Lucho", text: "lucho" },
        { name: "Team Tunita", text: "tunita" }
    ]

    // Normal
    // const zonesTemplate = [
    //     { name: "Zona Laboratorio Tequis", text: "laboratorio tequis" },
    //     { name: "Zona Canels", text: "canels" },
    //     { name: "Zona Seguros El Potosí", text: "seguros el potosi" },
    //     { name: "Zona Red Cola", text: "red cola" },
    //     { name: "Zona Tecate", text: "tecate" },
    //     { name: "Zona Moctezuma", text: "moctezuma" },
    //     { name: "Zona Nissan", text: "nissan" },
    //     { name: "Zona Mobil", text: "mobil" },
    //     { name: "Zona Lounge Ron Potosí", text: "lounge ron potosi" },
    //     { name: "Zona Azul", text: "azul" },
    //     { name: "Zona Oro", text: "oro" }
    // ]

    const [isLoading, setIsLoading] = useState(true)
    const [zone, setZone] = useState(null)
    const [activeComponentId, setActiveComponentId] = useState(null)

    const [quizOptions, setQuizOptions] = useState([])
    const [quizQuestionId, setQuizQuestionId] = useState(null)
    const [color, setColor] = useState(null)
    const [lottery, setLottery] = useState(null)
    const [riddle, setRiddle] = useState(null)

    const [selectedZone, setSelectedZone] = useState(null)
    const [selectedZoneToComponent, setSelectedZoneToComponent] = useState(null)

    const [balloonConfig, setBalloonConfig] = useState(null)
    const [balloonWinners, setBalloonWinners] = useState(null)

    const [noisemeterConfig, setNoisemeterConfig] = useState(null);
    const [noisemeterWinners, setNoisemeterWinners] = useState(null);

    const [luchoFestConfig, setLuchoFestConfig] = useState(null);
    const [luchoFestEmergencyTrigger, setLuchoFestEmergencyTrigger] = useState(0);

    const [lightShowConfig, setLightShowConfig] = useState(null);

    const [displayZoneName, setDisplayZoneName] = useState('')

    // ==========================================
    // ESTADOS NUEVOS PARA TIRO A GOL V2
    // ==========================================
    const [goalV2Config, setGoalV2Config] = useState(null);
    const [goalV2MatchState, setGoalV2MatchState] = useState(null);
    const [goalV2WinnerZone, setGoalV2WinnerZone] = useState(null);

    const [votingConfig, setVotingConfig] = useState(null);

    // const ToCanonicalZone = (raw, zonesTemplate = []) => {
    //     if (!raw) return null
    //     let s = String(raw).toLowerCase().trim()
    //     if (s.startsWith("zona ")) s = s.slice(5)
    //     s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    //     s = s.replace(/\s+/g, " ").trim()
    //     if (Array.isArray(zonesTemplate) && zonesTemplate.length) {
    //         const canonList = zonesTemplate.map(z => ({
    //             canon: String(z.text).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim(),
    //             original: z.text
    //         }))
    //         const hit = canonList.find(z => z.canon === s)
    //         if (hit) return hit.original
    //     }
    //     return s
    // }

    // =========================================================================
    // 2. FUNCIÓN DE NORMALIZACIÓN MÁS INTELIGENTE
    // =========================================================================
    const ToCanonicalZone = (raw, zonesTemplate = []) => {
        if (!raw) return null

        let s = String(raw).toLowerCase().trim()
        if (s.startsWith("zona ")) s = s.slice(5).trim()

        // Creamos una versión sin acentos para la comparación "sucia"
        const noAccents = (str) => str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, " ").trim();
        const rawNoAccents = noAccents(s);

        if (Array.isArray(zonesTemplate) && zonesTemplate.length) {
            // Buscamos coincidencia relajada (sin acentos) pero retornamos la versión ESTRICTA (con acentos)
            const hit = zonesTemplate.find(z => noAccents(z.name.toLowerCase()) === rawNoAccents || noAccents(z.text) === rawNoAccents);
            if (hit) return hit.text; // Retorna "lounge ron potosí" (con acento)
        }

        return s;
    }

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
            document.body.classList.remove('Quiz__Background__Femenil--Blue')
            document.body.classList.remove('Quiz__Background__Femenil--Golden')

            const response = await GetUserZone()
            if (response.success) {
                const raw = response.data?.name
                const canon = ToCanonicalZone(raw, zonesTemplate)
                setZone({ ...response.data, canonical: canon })
                setSelectedZoneToComponent(canon)
                setSelectedZone(response.data.name)

                // NUEVO: Consultamos el nombre visual de la fase activa
                const zonesRes = await GetActiveStadiumZones();
                let visualName = raw; 
                if (zonesRes.success) {
                    const rawClean = raw.toLowerCase().replace("zona ", "").trim();
                    const matchedZone = zonesRes.data.find(z => z.internalName === rawClean);
                    if (matchedZone) {
                        visualName = matchedZone.displayName;
                    }
                }
                setDisplayZoneName(visualName);
            }
        } catch (error) {
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        LoadPage()

        const handler = async (payload) => {
            const type = payload?.type
            if (!type) return

            switch (type.toLowerCase()) {
                case "welcome":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(1)
                    break
                case "wait":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(2)
                    break
                case "trivia":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(3)
                    break
                case "options":
                    await RemoveExtraClassesOfColorsDynamic()
                    if (payload.data?.options?.length > 0) {
                        setQuizQuestionId(payload.data.questionId)
                        setQuizOptions(payload.data.options)
                        setColor(null)
                        setLottery(null)
                        setActiveComponentId(3.1)
                    }
                    break
                case "colores":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(4)
                    break
                case "setzonecolor":
                    if (payload?.color) {
                        setColor(payload.color)
                        setQuizQuestionId(null)
                        setQuizOptions(null)
                        setLottery(null)
                        setActiveComponentId(4.1)
                    }
                    break
                case "loteria":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(5)
                    break
                case "lotteryboard":
                    await RemoveExtraClassesOfColorsDynamic()
                    const response = await GetLotteryData(payload)
                    if (response.success) {
                        setColor(null); setQuizQuestionId(null); setQuizOptions(null);
                        setLottery(response.data)
                        setActiveComponentId(5.1)
                    } else {
                        const errorMessage = response?.message
                        if (errorMessage) {
                            console.log(errorMessage)
                        } else {
                            const responseNewData = await GetNewLotteryData(payload)
                            if (responseNewData.success) {
                                setColor(null); setQuizQuestionId(null); setQuizOptions(null);
                                setLottery(responseNewData.data)
                                await SaveLotteryData(responseNewData.data)
                                setActiveComponentId(5.1)
                            }
                        }
                    }
                    break
                case "start":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(7)
                    break
                case "thanks":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(8)
                    break

                // ==========================================
                // TIRO A GOL V2 (AFICIONADO)
                // ==========================================
                case "goal.created":
                    await RemoveExtraClassesOfColorsDynamic();
                    setGoalV2Config(payload.payload?.cfg || {});
                    setGoalV2MatchState({ matchId: payload.payload?.matchId, phase: 'WAITING' });
                    setGoalV2WinnerZone(null);
                    setActiveComponentId(15); // Pantalla de "Prepárate"
                    break;

                case "goal.started":
                    await RemoveExtraClassesOfColorsDynamic();
                    setGoalV2MatchState(prev => ({ ...prev, matchId: payload.payload?.matchId, phase: 'RUNNING' }));
                    setGoalV2WinnerZone(null);
                    setActiveComponentId(15.1); // Pantalla del Botón
                    break;

                case "goal.progress":
                    if (payload.payload?.elapsedMilliseconds !== undefined) {
                        setGoalV2MatchState(prev => ({ ...prev, ...payload.payload, phase: 'RUNNING' }));
                        setActiveComponentId(15.1);
                    }
                    break;

                case "goal.finished":
                    if (payload.payload?.finalZonesProgress !== undefined) {
                        await RemoveExtraClassesOfColorsDynamic();
                        setGoalV2MatchState(prev => ({ ...prev, phase: 'FINISHED' }));
                        setGoalV2WinnerZone(payload.payload?.winner);
                        setActiveComponentId(15.1);
                    }
                    break;

                case "goal.prepare":
                case "goal.reset":
                    await RemoveExtraClassesOfColorsDynamic();
                    setGoalV2MatchState({ matchId: payload.payload?.matchId, phase: 'WAITING' });
                    setGoalV2WinnerZone(null);
                    setActiveComponentId(15);
                    break;

                // ==========================================
                // OTRAS DINÁMICAS (Se mantienen intactas)
                // ==========================================
                case "ballons":
                    await RemoveExtraClassesOfColorsDynamic()
                    setBalloonConfig(null); setBalloonWinners(null);
                    setActiveComponentId(9)
                    break
                case "ballonsgame":
                    await RemoveExtraClassesOfColorsDynamic()
                    setActiveComponentId(9.1)
                    break;
                case "balloon.prepare": {
                    await RemoveExtraClassesOfColorsDynamic()
                    const d = payload.data || {}
                    setBalloonConfig({ matchId: d.matchId, startAt: d.startAt, endsAt: d.endsAt, targetTapsPerBalloon: d.targetTapsPerBalloon });
                    setBalloonWinners(null)
                    setActiveComponentId(9.1)
                    break;
                }
                case "balloon.show-winners": {
                    const d = payload.data || {}
                    setBalloonWinners({ winnerType: d.winnerType || "none", winners: d.winners || [], results: d.results || [] })
                    setActiveComponentId(9.1)
                    break
                }
                case "balloon.reset":
                    await RemoveExtraClassesOfColorsDynamic()
                    setBalloonConfig(null); setBalloonWinners(null);
                    setActiveComponentId(9)
                    break;
                case "riddle":
                    await RemoveExtraClassesOfColorsDynamic(); 
                    sessionStorage.removeItem('eudnrlanrbaewq');
                    setRiddle(null);
                    setActiveComponentId(10); 
                    break;
                case "riddle_reset":
                case "resetriddleresults":
                    await RemoveExtraClassesOfColorsDynamic();
                    sessionStorage.removeItem('eudnrlanrbaewq');
                    setRiddle(null);
                    setActiveComponentId(10);
                    break;
                case "newquestionriddler":
                    await RemoveExtraClassesOfColorsDynamic();
                    sessionStorage.removeItem('eudnrlanrbaewq');
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(10.1); }
                    break;
                case "resumequestionriddler":
                case "riddledisplayitem":
                    await RemoveExtraClassesOfColorsDynamic();
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(10.1); }
                    break;
                case "quizzwithimageandoptions":
                    await RemoveExtraClassesOfColorsDynamic(); setActiveComponentId(10); break
                case "newquestionquizzwithimageandoptions":
                    await RemoveExtraClassesOfColorsDynamic()
                    sessionStorage.removeItem('eudnrlanrbaewq')
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(11.1); }
                    break
                case "resumequestionquizzwithimageandoptions":
                    await RemoveExtraClassesOfColorsDynamic()
                    if (payload?.data) { setRiddle(payload.data); setActiveComponentId(11.1); }
                    break
                case "frontpagenoisemeter":
                    await RemoveExtraClassesOfColorsDynamic(); setNoisemeterConfig(null); setNoisemeterWinners(null); setActiveComponentId(12); break
                case 'noisemeter.prepare':
                    await RemoveExtraClassesOfColorsDynamic(); setNoisemeterConfig(payload.data); setNoisemeterWinners(null); setActiveComponentId(12.1); break;
                case 'noisemeter.finished':
                    setNoisemeterWinners(payload.data); setActiveComponentId(12.1); break;
                case "frontpagenoisemeterv2":
                    await RemoveExtraClassesOfColorsDynamic(); setNoisemeterConfig(null); setNoisemeterWinners(null); setActiveComponentId(32); break
                case 'noisemeterv2.prepare':
                    await RemoveExtraClassesOfColorsDynamic(); setNoisemeterConfig(payload.data); setNoisemeterWinners(null); setActiveComponentId(32.1); break;
                case 'noisemeterv2.finished':
                    setNoisemeterWinners(payload.data); setActiveComponentId(32.1); break;
                case "frontpageluchofest":
                    await RemoveExtraClassesOfColorsDynamic(); setLuchoFestConfig(null); setActiveComponentId(13); break
                case "luchofest.start":
                    await RemoveExtraClassesOfColorsDynamic(); setLuchoFestConfig(payload.data); setActiveComponentId(13.1); break
                case "luchofest.stop":
                    await RemoveExtraClassesOfColorsDynamic(); setLuchoFestConfig(null); setActiveComponentId(13); break
                case "luchofest.emergency_promo":
                    setLuchoFestEmergencyTrigger(prev => prev + 1); break
                case "lightshow.prepare":
                    await RemoveExtraClassesOfColorsDynamic(); setLightShowConfig({ ...payload.data, isRunning: false }); setActiveComponentId(14); break
                case "lightshow.start":
                    setLightShowConfig(prevConfig => ({ ...prevConfig, ...payload.data, isRunning: true })); break
                case "lightshow.stop":
                    setLightShowConfig(prevConfig => ({ ...prevConfig, isRunning: false })); break
                case "lightshow.late_join":
                    await RemoveExtraClassesOfColorsDynamic();
                    setLightShowConfig({ ...payload.data.config, isRunning: payload.data.isRunning, serverStartTimestampMilliseconds: payload.data.serverStartTimestampMilliseconds })
                    setActiveComponentId(14); break
                case "force_relogin":
                    // 1. Borramos la memoria local (zona guardada)
                    await DeleteSessionData();
                    // 2. Recargamos la página a la fuerza para mandarlo a Dashboard/Zones
                    window.location.reload(true); 
                    break;
                // case 'voting.start':
                //     setLottery(null); setQuestion(message.data); setResults(null);
                //     setActiveComponentId(16); // ID 16 para tu Voting
                //     break;
                // case 'voting.start':
                //     setVotingConfig(payload.data);
                //     setActiveComponentId(16);
                //     break;
                case 'voting.start':
                    setLottery(null); 
                    setVotingConfig(payload.data); // O setQuestion(payload.data) si le pusiste así al estado
                    //setResults(null);
                    setActiveComponentId(16);
                    break;
                case 'sequence.frontpage':
                case 'sequence.layout':
                case 'sequence.update':
                case 'sequence.reset':
                    setActiveComponentId(35);
                    break;
                case 'tugofwar.cover':
                case 'tugofwar_cover':
                case 'tugofwar_cover_shown':
                case 'tugofwar.game_scene':
                case 'tugofwar_game_scene':
                case 'tugofwar_game_scene_shown':
                case 'tugofwar.game_ready':
                case 'tugofwar_game_ready':
                case 'tugofwar.countdown':
                case 'tugofwar_countdown':
                case 'tugofwar_countdown_tick':
                case 'tugofwar.started':
                case 'tugofwar_started':
                case 'tugofwar_match_started':
                case 'tugofwar.telemetry':
                case 'tugofwar_telemetry':
                case 'tugofwar.sudden_death':
                case 'tugofwar.paused':
                case 'tugofwar.resumed':
                case 'tugofwar.game_over':
                case 'tugofwar.finished':
                case 'tugofwar.reset':
                    await RemoveExtraClassesOfColorsDynamic();
                    setActiveComponentId(47);
                    break;
                case 'memory.cover':
                case 'memory_cover':
                case 'memory_cover_shown':
                case 'memory.game_scene':
                case 'memory_game_scene':
                case 'memory_game_shown':
                case 'memory.game_ready':
                case 'memory_game_ready':
                case 'memory_sync_state':
                case 'memory_state':
                case 'memory.countdown':
                case 'memory_countdown':
                case 'memory_countdown_started':
                case 'memory.preview':
                case 'memory_preview':
                case 'memory_preview_start':
                case 'memory_preview_ended':
                case 'memory.playing_started':
                case 'memory_playing_started':
                case 'memory_start':
                case 'memory_game_start':
                case 'memory_card_flipped':
                case 'memory_match_success':
                case 'memory_match_failed':
                case 'memory_cards_unflipped':
                case 'memory_telemetry':
                case 'memory_all_pairs_matched':
                case 'memory_finished':
                case 'memory_game_over':
                case 'memory_game_finished':
                case 'memory_reset':
                case 'memory_game_reset':
                case 'memory_match_reset':
                    await RemoveExtraClassesOfColorsDynamic();
                    setActiveComponentId(48);
                    break;
                default:
                    await RemoveExtraClassesOfColorsDynamic(); setActiveComponentId(null); break
            }
        }

        SetSocketMessageHandler(handler)

        return () => {
            ClearSocketMessageHandler()
        }
    }, [])


    return (
        isLoading ? (
            <p>Cargando...</p>
        ) : (
            <>
                <div className="Sections">
                    <div className="Sections__Tiles">
                        {/* <p className='text-center'>Zona: {selectedZone}</p> */} {/* Normal */}

                        <p className='text-center'>Zona: {displayZoneName}</p>

                        {/*<p className='text-center'>{/*Zona:*/}
                            {/* Daikin */}
                            {/* {selectedZone.toLowerCase() === 'zona canels' && ' Pichon-kun'}
                            {selectedZone.toLowerCase() === 'zona tecate' && ' Tunita'}
                            {selectedZone.toLowerCase() === 'zona azul' && ' Pichon-kun'}
                            {selectedZone.toLowerCase() === 'zona oro' && ' Tunita'} */}

                            {/* La Moderna */}
                            {/* {selectedZone.toLowerCase() === 'zona canels' && ' Codito'}
                            {selectedZone.toLowerCase() === 'zona tecate' && ' Spaghetti'}
                            {selectedZone.toLowerCase() === 'zona azul' && ' Codito'}
                            {selectedZone.toLowerCase() === 'zona oro' && ' Spaghetti'} */}

                            {/* Normal */}
                            {/* {selectedZone.toLowerCase() === 'zona canels' && ' Lucho'}
                            {selectedZone.toLowerCase() === 'zona tecate' && ' Tunita'}
                            {selectedZone.toLowerCase() === 'zona azul' && ' Lucho'}
                            {selectedZone.toLowerCase() === 'zona oro' && ' Tunita'} */}

                            {/* Carrera Atleti */}
                            {/* {selectedZone ? (
                                <>
                                    Zona:
                                    {selectedZone.toLowerCase() === 'zona canels' && ' Lucho'}
                                    {selectedZone.toLowerCase() === 'zona tecate' && ' Tunita'}
                                </>
                            ) : (
                                <p className='text-center'>Zona: {displayZoneName}</p>
                            )} */}
                        {/*</p>*/}

                        {activeComponentId === 1 && <Welcome />}
                        {activeComponentId === 2 && <Wait />}
                        {activeComponentId === 3 && <Wait />}
                        {activeComponentId === 3.1 && <Quiz questionId={quizQuestionId} options={quizOptions} />}
                        {activeComponentId === 4 && <InstructionsColors />}
                        {activeComponentId === 4.1 && <Colors color={color} />}
                        {activeComponentId === 5 && <Wait />}
                        {activeComponentId === 5.1 && <Lottery lottery={lottery} />}
                        {activeComponentId === 6 && <Wait />}
                        {activeComponentId === 7 && <Welcome />}
                        {activeComponentId === 8 && <Thanks />}
                        {activeComponentId === 9 && <Wait />}
                        {activeComponentId === 9.1 && (<Balloons config={balloonConfig} winners={balloonWinners} zone={selectedZoneToComponent} />)}
                        {activeComponentId === 10 && <Wait />}
                        {activeComponentId === 10.1 && <Riddle riddle={riddle} />}
                        {activeComponentId === 11.1 && <QuizzWithImageAndOptions quizz={riddle} />}
                        {activeComponentId === 12 && <FrontPageNoisemeter />}
                        {activeComponentId === 12.1 && (<Noisemeter config={noisemeterConfig} winners={noisemeterWinners} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 32 && <FrontPageNoisemeterV2 />}
                        {activeComponentId === 32.1 && (<NoisemeterV2 config={noisemeterConfig} winners={noisemeterWinners} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 13 && <Wait />}
                        {activeComponentId === 13.1 && (<LuchoFest isPracticeRoundParameter={luchoFestConfig?.isPracticeRound} winningZoneParameter={luchoFestConfig?.winningZone} gameSequence={luchoFestConfig?.gameSequence} userZoneParameter={selectedZoneToComponent} emergencyTrigger={luchoFestEmergencyTrigger} />)}
                        {activeComponentId === 14 && (<LightShow config={lightShowConfig} />)}

                        {/* AQUI RENDERIZAMOS EL TIRO A GOL V2 PASANDO selectedZone PARA EVITAR DUPLICADOS */}
                        {activeComponentId === 15 && (<GoalV2 matchState={goalV2MatchState} config={goalV2Config} winnerZone={goalV2WinnerZone} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 15.1 && (<GoalV2 matchState={goalV2MatchState} config={goalV2Config} winnerZone={goalV2WinnerZone} userZone={selectedZoneToComponent} />)}
                        
                        {activeComponentId === 16 && (<Voting config={votingConfig} userZone={selectedZoneToComponent} />)}
                        {activeComponentId === 35 && (<SequenceFan />)}
                        {activeComponentId === 47 && (<TugOfWarFan />)}
                        {activeComponentId === 47.1 && (<TugOfWarFan />)}
                        {activeComponentId === 48 && (<MemoryPlayer />)}
                        {activeComponentId === 48.1 && (<MemoryPlayer />)}
                        
                        {!activeComponentId && <Welcome />}
                    </div>
                </div>
            </>
        )
    )
}

export { Sections };